export default "__VITE_ASSET__P2Qr9spf__"